export default `<!--
  - Copyright (C) CEDE Labs, SAS - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited
  - Proprietary and confidential
  - Written by CEDE Labs team <team@cedelabs.io>, September 2021
  -->

<svg viewBox="0 0 104 103" xmlns="http://www.w3.org/2000/svg"><path d="m3.94 88.41c4.79 5.08 31.13 29.42 72.47 1.17 29.9-23.28 29.15-73.75 26.28-89-1 2.22-35.69 78.26-98.75 87.83zm98.75-87.84c-.37-.15-38.83-5.39-76.85 19.1-23.61 15.2-26.74 37.46-25.66 52.33 55.27-6.22 101.25-69.68 102.51-71.43z" fill="#97c554"/><path d="m102.69.57c-.37-.15-38.83-5.39-76.85 19.1-23.61 15.2-26.74 37.46-25.66 52.33 55.27-6.22 101.25-69.68 102.51-71.43z" fill="#709b30"/></svg>
`;
